import { atom } from "recoil";

type CreditLoadingScope = "RIGHT PANEL" | "LIST";

const settlementManagementCreditLoadingScope = atom<
  CreditLoadingScope | undefined
>({
  key: "settlementManagementCreditLoadingScope",
  default: undefined,
});

export default settlementManagementCreditLoadingScope;
